import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";

import {
  vsObjectName as contractInstanceName,
  defaultSort,
} from "./contractInstance";
import { vsObjectName as contactBookName } from "../../../ContactBook/shared/configs/contactBook";
import { RecordDataSource } from "../../../records/grids";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";

export const vsObjectName = "contractInstanceContact";

const url = "/api/contract/contact";

contractContactConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function contractContactConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  configureColumnDefinitionSet(columnDefinitionSetServiceProvider);
  configureGrid(recordGridViewServiceProvider);
}
function configureColumnDefinitionSet(
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionServiceName,
    ColumnDefinitionSetServiceName,
    (
      columnDefinitionService: ColumnDefinitionService,
      columnDefinitionSetService: ColumnDefinitionSetService
    ): ColDef[] => {
      return [
        columnDefinitionService.getStringColDef({
          field: "ContractContactTypeName",
          header: "Contact Type",
        }),
        ...columnDefinitionSetService.getColumnDefinitionSet(contactBookName),
        ...columnDefinitionSetService.getColumnDefinitionSet(
          contractInstanceName
        ),
      ];
    },
  ]);
}

function configureGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    (serverUtility: ServerUtility): GridConfiguration => ({
      columnDefinitionSet: vsObjectName,
      defaultSort: `${defaultSort},ContractContactTypeName,AddressBookName`,
      namePlural: "Contract Contacts",
      nameSingular: "Contract Contact",
      gridDataSource: new RecordDataSource(serverUtility, url),
    }),
  ]);
}
